export const ProjectInfo = {
    release_version: '$APP_VERSION_VALUE_REPLACED_AT_BUILD_TIME$',
    app_name: {
        all: {
            token: '$APP_NAME_ALL$',
            value: 'all'
        },
        tag: {
            token: '$APP_NAME_TAG$',
            value: 'tag'
        },
        skin: {
            token: '$APP_NAME_SKIN_DESKTOP$',
            value: 'skin'
        },
        skin_plugin_sidebar: {
            token: '$APP_NAME_SKIN_PLUGIN_SIDEBAR$',
            value: 'skin_plugin_sidebar'
        },
        skin_plugin_multi_cam: {
            token: '$APP_NAME_SKIN_PLUGIN_MULTI_CAM$',
            value: 'skin_plugin_multi_cam'
        },
        skin_plugin_multi_stream: {
            token: '$APP_NAME_SKIN_PLUGIN_MULTI_STREAM$',
            value: 'skin_plugin_multi_stream'
        },
        skin_plugin_related_videos: {
            token: '$APP_NAME_SKIN_PLUGIN_RELATED_VIDEOS$',
            value: 'skin_plugin_related_videos'
        },
        skin_plugin_sample: {
            token: '$APP_NAME_SKIN_PLUGIN_SAMPLE$',
            value: 'skin_plugin_sample'
        },
        tag_plugin_sample: {
            token: '$APP_NAME_TAG_PLUGIN_SAMPLE$',
            value: 'tag_plugin_sample'
        },
        iframe: {
            token: '$APP_NAME_IFRAME$',
            value: 'iframe'
        },
        iframe_php: {
            token: '$APP_NAME_IFRAME$',
            value: 'iframe_php'
        },
        iframe_companion: {
            token: '$APP_NAME_IFRAME_COMPANION$',
            value: 'iframe_companion'
        }
    },
    app_storage_prefix: {
        smart_tag: {
            token: '$STORAGE_NAME_SMART_TAG$',
            value: 'smart-tag'
        }
    },
    app_compile_time: {
        tag: {
            token: '$COMPILE_TIME_TAG$'
        },
        skin: {
            token: '$COMPILE_TIME_SKIN_DESKTOP$'
        },
        skin_plugin_sidebar: {
            token: '$COMPILE_TIME_SKIN_PLUGIN_SIDEBAR$'
        },
        skin_plugin_multi_cam: {
            token: '$COMPILE_TIME_SKIN_PLUGIN_MULTI_CAM$'
        },
        skin_plugin_multi_stream: {
            token: '$COMPILE_TIME_SKIN_PLUGIN_MULTI_STREAM$'
        },
        skin_plugin_related_videos: {
            token: '$COMPILE_TIME_SKIN_PLUGIN_RELATED_VIDEOS$'
        },
        skin_plugin_sample: {
            token: '$COMPILE_TIME_SKIN_PLUGIN_SAMPLE$'
        },
        tag_plugin_sample: {
            token: '$COMPILE_TIME_TAG_PLUGIN_SAMPLE$'
        },
        iframe: {
            token: '$COMPILE_TIME_IFRAME$'
        },
        iframe_php: {
            token: '$COMPILE_TIME_IFRAME_PHP$'
        },
        iframe_companion: {
            token: '$COMPILE_TIME_IFRAME_COMPANION$'
        }
    },
    app_source_dir: {
        tag: {
            token: '$SOURCE_DIR_SMART_TAG$',
            value: './src/tag/'
        },
        skin: {
            token: '$SOURCE_DIR_SKIN$',
            value: './src/skin/'
        },
        skin_plugin_sidebar: {
            token: '$SOURCE_DIR_SKIN_PLUGIN_SIDEBAR$',
            value: './src/plugins/skin/plugin_sidebar/'
        },
        skin_plugin_multi_cam: {
            token: '$SOURCE_DIR_SKIN_PLUGIN_MULTI_CAM$',
            value: './src/plugins/skin/plugin_multi_cam/'
        },
        skin_plugin_multi_stream: {
            token: '$SOURCE_DIR_SKIN_PLUGIN_MULTI_STREAM$',
            value: './src/plugins/skin/plugin_multi_stream/'
        },
        skin_plugin_related_videos: {
            token: '$SOURCE_DIR_SKIN_PLUGIN_RELATED_VIDEOS$',
            value: './src/plugins/skin/plugin_related_videos/'
        },
        skin_plugin_sample: {
            token: '$SOURCE_DIR_SKIN_PLUGIN_SAMPLE$',
            value: './src/plugins/skin/plugin_sample/'
        },
        tag_plugin_sample: {
            token: '$SOURCE_DIR_TAG_PLUGIN_SAMPLE$',
            value: './src/plugins/tag/plugin_sample/'
        },
        iframe: {
            token: '$SOURCE_DIR_IFRAME$',
            value: './src/iframe/'
        },
        iframe_php: {
            token: '$SOURCE_DIR_IFRAME_PHP$',
            value: './src/iframe/'
        },
        iframe_companion: {
            token: '$SOURCE_DIR_IFRAME_COMPANION$',
            value: './src/iframe_companion/'
        }
    },
    app_output_dir: {
        tag: {
            token: '$DIR_SMART_TAG$',
            value: 'smart-tag'
        },
        skin: {
            token: '$DIR_SKIN$',
            value: 'smart-tag-skin'
        },
        skin_plugin_sidebar: {
            token: '$DIR_SKIN_PLUGIN_SIDEBAR$',
            value: 'smart-tag-skin-plugin-sidebar'
        },
        skin_plugin_multi_cam: {
            token: '$DIR_SKIN_PLUGIN_MULTI_CAM$',
            value: 'smart-tag-skin-plugin-multi-cam'
        },
        skin_plugin_multi_stream: {
            token: '$DIR_SKIN_PLUGIN_MULTI_STREAM$',
            value: 'smart-tag-skin-plugin-multi-stream'
        },
        skin_plugin_related_videos: {
            token: '$DIR_SKIN_PLUGIN_RELATED_VIDEOS$',
            value: 'smart-tag-skin-plugin-related-videos'
        },
        skin_plugin_sample: {
            token: '$DIR_SKIN_PLUGIN_SAMPLE$',
            value: 'smart-tag-skin-plugin-sample'
        },
        tag_plugin_sample: {
            token: '$DIR_TAG_PLUGIN_SAMPLE$',
            value: 'smart-tag-plugin-sample'
        },
        iframe: {
            token: '$DIR_IFRAME$',
            value: 'iframe'
        },
        iframe_php: {
            token: '$DIR_IFRAME_PHP$',
            value: 'iframe'
        },
        iframe_companion: {
            token: '$DIR_IFRAME_COMPANION$',
            value: 'iframe'
        }
    },
    app_namespace: {
        tag: {
            token: '$SMART_TAG_NAMESPACE$',
            value: 'SmartTag'
        }
    },
    app_output_file: {
        tag: {
            js: {
                min: {
                    token: '$SMART_TAG_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.js'
                }
            }
        },
        skin: {
            js: {
                min: {
                    token: '$SKIN_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.js'
                }
            },
            css: {
                min: {
                    token: '$SKIN_CSS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.css'
                }
            }
        },
        skin_plugin_sidebar: {
            js: {
                min: {
                    token: '$SKIN_PLUGIN_SIDEBAR_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.sidebar.js'
                }
            },
            css: {
                min: {
                    token: '$SKIN_PLUGIN_SIDEBAR_CSS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.sidebar.css'
                }
            }
        },
        skin_plugin_multi_cam: {
            js: {
                min: {
                    token: '$SKIN_PLUGIN_MULTI_CAM_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.multi.cam.js'
                }
            },
            css: {
                min: {
                    token: '$SKIN_PLUGIN_MULTI_CAM_CSS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.multi.cam.css'
                }
            }
        },
        skin_plugin_multi_stream: {
            js: {
                min: {
                    token: '$SKIN_PLUGIN_MULTI_STREAM_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.multi.stream.js'
                }
            },
            css: {
                min: {
                    token: '$SKIN_PLUGIN_MULTI_STREAM_CSS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.multi.stream.css'
                }
            }
        },
        skin_plugin_related_videos: {
            js: {
                min: {
                    token: '$SKIN_PLUGIN_RELATED_VIDEOS_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.related.videos.js'
                }
            },
            css: {
                min: {
                    token: '$SKIN_PLUGIN_RELATED_VIDEOS_CSS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.related.videos.css'
                }
            }
        },
        skin_plugin_sample: {
            js: {
                min: {
                    token: '$SKIN_PLUGIN_SAMPLE_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.sample.js'
                }
            },
            css: {
                min: {
                    token: '$SKIN_PLUGIN_SAMPLE_CSS_FILE_NAME_MIN$',
                    value: 'smart.tag.skin.plugin.sample.css'
                }
            }
        },
        tag_plugin_sample: {
            js: {
                min: {
                    token: '$TAG_PLUGIN_SAMPLE_JS_FILE_NAME_MIN$',
                    value: 'smart.tag.plugin.sample.js'
                }
            },
            css: {
                min: {
                    token: '$TAG_PLUGIN_SAMPLE_CSS_FILE_NAME_MIN$',
                    value: 'smart.tag.plugin.sample.css'
                }
            }
        },
        iframe: {
            php: {
                token: '$IFRAME_PHP_FILE_NAME$',
                value: 'player.php'
            },
            js: {
                min: {
                    token: '$IFRAME_JS_FILE_NAME_MIN$',
                    value: 'player.js'
                }
            }
        },
        iframe_php: {
            php: {
                token: '$IFRAME_PHP_FILE_NAME$',
                value: 'player.php'
            }
        },
        iframe_companion: {
            js: {
                min: {
                    token: '$IFRAME_COMPANION_JS_FILE_NAME_MIN$',
                    value: 'player.companion.js'
                }
            }
        }
    },
    envelope: {
        localhost: {
            token: '$ENVELOPE_NAME_LOCALHOST$',
            value: 'localhost'
        },
        automation: {
            token: '$ENVELOPE_NAME_AUTOMATION$',
            value: 'automation'
        },
        platypus: {
            token: '$ENVELOPE_NAME_PLATYPUS$',
            value: 'platypus'
        },
        dev: {
            token: '$ENVELOPE_NAME_DEV$',
            value: 'dev'
        },
        branch: {
            token: '$ENVELOPE_NAME_BRANCH$',
            value: 'branch'
        },
        stage: {
            token: '$ENVELOPE_NAME_STAGE$',
            value: 'stage'
        },
        'stage-hub': {
            token: '$ENVELOPE_NAME_STAGE_HUB$',
            value: 'stage-hub'
        },
        perf: {
            token: '$ENVELOPE_NAME_PERF$',
            value: 'perf'
        },
        standby: {
            token: '$ENVELOPE_NAME_STANDBY$',
            value: 'standby'
        },
        preview: {
            token: '$ENVELOPE_NAME_PREVIEW$',
            value: 'preview'
        },
        prod: {
            token: '$ENVELOPE_NAME_PROD$',
            value: 'prod'
        }
    },
    envelope_output_dir: {
        localhost: {
            token: '$ENVELOPE_OUT_DIR_LOCALHOST$',
            value: 'localhost'
        },
        automation: {
            token: '$ENVELOPE_OUT_DIR_AUTOMATION$',
            value: 'release'
        },
        platypus: {
            token: '$ENVELOPE_OUT_DIR_PLATYPUS$',
            value: 'release'
        },
        dev: {
            token: '$ENVELOPE_OUT_DIR_DEV$',
            value: 'release'
        },
        branch: {
            token: '$ENVELOPE_OUT_DIR_BRANCH$',
            value: 'release'
        },
        stage: {
            token: '$ENVELOPE_OUT_DIR_STAGE$',
            value: 'release'
        },
        perf: {
            token: '$ENVELOPE_OUT_DIR_PERF$',
            value: 'release/latest'
        },
        'stage-hub': {
            token: '$ENVELOPE_OUT_DIR_STAGE_HUB$',
            value: 'release'
        },
        standby: {
            token: '$ENVELOPE_OUT_DIR_STANDBY$',
            value: 'release'
        },
        preview: {
            token: '$ENVELOPE_OUT_DIR_PREVIEW$',
            value: 'release'
        },
        prod: {
            token: '$ENVELOPE_OUT_DIR_PROD$',
            value: 'release'
        }
    },
    domain: {
        localhost: {
            token: '$DOMAIN_LOCALHOST$',
            value: 'localhost'
        },
        automation: {
            token: '$DOMAIN_AUTOMATION$',
            value: 'automation-player-services.cbs.com'
        },
        dev: {
            token: '$DOMAIN_BRANCH$',
            value: 'branch-player-services.cbs.com'
        },
        branch: {
            token: '$DOMAIN_BRANCH$',
            value: 'branch-player-services.cbs.com'
        },
        stage: {
            token: '$DOMAIN_STAGE$',
            value: 'stage-player-services.cbs.com'
        },
        perf: {
            token: '$DOMAIN_PERF$',
            value: 'perf-player-services.cbs.com'
        },
        'stage-hub': {
            token: '$DOMAIN_STAGE_HUB$',
            value: 'stage-hub-player-services.cbs.com'
        },
        preview: {
            token: '$DOMAIN_PREVIEW$',
            value: 'preview-player-services.cbs.com'
        },
        prod: {
            token: '$DOMAIN_PROD$',
            value: 'player-services.cbs.com'
        }
    },
    dependencies: {
        bundle: {
            tag: {
                dir: {
                    token: '$TAG_DEPENDENCIES_DIR_NAME$',
                    value: 'dependencies'
                },
                player: {
                    version: {
                        player_version_token: '$TAG_PLAYER_VERSION$',
                        value: {
                            localhost: '2.46.3',
                            automation: '2.46.3',
                            platypus: '2.46.3',
                            dev: '2.46.3',
                            branch: '2.46.3',
                            stage: '2.46.3',
                            'stage-hub': '2.46.3',
                            standby: '2.46.3',
                            preview: '2.46.3',
                            prod: '2.46.3',
                            perf: '2.46.3'
                        }
                    },
                    dir: {
                        source: {
                            token: '$TAG_PLAYER_DEPENDENCY_DIR$',
                            value: 'vtg/avia'
                        },
                        output: {
                            token: '$TAG_PLAYER_BUNDLE_DIR$',
                            value: 'vtg/avia'
                        }
                    },
                    blank_mp4: {
                        dir: {
                            source: {
                                token: '$TAG_PLAYER_DEPENDENCY_BLANK_MP4_DIR$',
                                value: 'vtg'
                            },
                            output: {
                                token: '$TAG_PLAYER_BUNDLE_BLANK_MP4_DIR$',
                                value: 'vtg'
                            }
                        },
                        filename: {
                            token: '$TAG_PLAYER_DEPENDENCY_BLANK_MP4_FILENAME$',
                            value: 'uvp_blank.mp4'
                        }
                    },
                    hlsjs: {
                        dir: {
                            source: {
                                token: '$TAG_PLAYER_DEPENDENCY_HLSJS_DIR$',
                                value: 'hls.js/1.5.8'
                            },
                            output: {
                                token: '$TAG_PLAYER_BUNDLE_HLSJS_DIR$',
                                value: 'hls.js/1.5.8'
                            }
                        },
                        filename: {
                            token: '$TAG_PLAYER_DEPENDENCY_HLSJS_FILENAME$',
                            value: 'hls.min.js'
                        }
                    },
                    shaka: {
                        dir: {
                            source: {
                                token: '$TAG_PLAYER_DEPENDENCY_SHAKA_DIR$',
                                value: 'shaka/4.14.1'
                            },
                            output: {
                                token: '$TAG_PLAYER_BUNDLE_SHAKA_DIR$',
                                value: 'shaka/4.14.1'
                            }
                        },
                        filename: {
                            token: '$TAG_PLAYER_DEPENDENCY_SHAKA_FILENAME$',
                            value: 'shaka-player.compiled.js'
                        }
                    }
                }
            }
        },
        ima: {
            namespace: {
                token: '$IMA3_NAMESPACE$',
                value: 'google.ima.settings'
            },
            url: {
                regular: {
                    token: '$IMA3_URL_NORMAL$',
                    value: 'https://s0.2mdn.net/instream/html5/ima3.js'
                }
            }
        },
        ima_dai: {
            namespace: {
                token: '$IMA_DAI_NAMESPACE$',
                value: 'google.ima.dai'
            },
            url: {
                regular: {
                    token: '$IMA_DAI_URL_NORMAL$',
                    value: 'https://imasdk.googleapis.com/js/sdkloader/ima3_dai.js'
                }
            }
        },
        player: {
            namespace: {
                token: '$PLAYER_NAMESPACE$',
                value: 'avia'
            },
            url: {
                regular: {
                    token: '$PLAYER_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/player/avia.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_FILE_NAME_NORMAL$',
                    value: 'avia.min.js'
                }
            }
        },
        player_ui: {
            namespace: {
                token: '$PLAYER_UI_NAMESPACE$',
                value: 'avia.ui'
            },
            url: {
                regular: {
                    token: '$PLAYER_UI_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/plugins/ui/avia.ui.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_UI_FILE_NAME_NORMAL$',
                    value: 'avia.ui.min.js'
                }
            }
        },
        player_dash_adapter: {
            namespace: {
                token: '$PLAYER_DASH_ADAPTER_NAMESPACE$',
                value: 'avia.dash'
            },
            url: {
                regular: {
                    token: '$PLAYER_DASH_ADAPTER_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/plugins/dash/avia.dash.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_DASH_ADAPTER_FILE_NAME_NORMAL$',
                    value: 'avia.dash.min.js'
                }
            }
        },
        player_gam_plugin: {
            namespace: {
                token: '$PLAYER_GAM_PLUGIN_NAMESPACE$',
                value: 'avia.gam'
            },
            url: {
                regular: {
                    token: '$PLAYER_GAM_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/plugins/gam/avia.gam.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_GAM_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.gam.min.js'
                }
            }
        },
        player_fw_plugin: {
            namespace: {
                token: '$PLAYER_FW_PLUGIN_NAMESPACE$',
                value: 'avia.fw'
            },
            url: {
                regular: {
                    token: '$PLAYER_FW_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/plugins/fw/avia.fw.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_FW_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.fw.min.js'
                }
            }
        },
        player_hls_adapter: {
            namespace: {
                token: '$PLAYER_HLS_ADAPTER_NAMESPACE$',
                value: 'avia.hls'
            },
            url: {
                regular: {
                    token: '$PLAYER_HLS_ADAPTER_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/plugins/hls/avia.hls.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_HLS_ADAPTER_FILE_NAME_NORMAL$',
                    value: 'avia.hls.min.js'
                }
            }
        },
        player_hlsjs_plugin: {
            namespace: {
                token: '$PLAYER_HLSJS_PLUGIN_NAMESPACE$',
                value: 'avia.hlsjs'
            },
            url: {
                regular: {
                    token: '$PLAYER_HLSJS_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/plugins/hlsjs/avia.hlsjs.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_HLSJS_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.hlsjs.min.js'
                }
            }
        },
        player_shaka_plugin: {
            namespace: {
                token: '$PLAYER_SHAKA_PLUGIN_NAMESPACE$',
                value: 'avia.shaka'
            },
            url: {
                regular: {
                    token: '$PLAYER_SHAKA_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/plugins/shaka/avia.shaka.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_SHAKA_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.shaka.min.js'
                }
            }
        },
        player_lg_plugin: {
            namespace: {
                token: '$PLAYER_LG_PLUGIN_NAMESPACE$',
                value: 'avia.lg'
            },
            url: {
                regular: {
                    token: '$PLAYER_LG_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/extensions/lg/avia.lg.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_LG_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.lg.min.js'
                }
            }
        },
        player_samsung_plugin: {
            namespace: {
                token: '$PLAYER_SAMSUNG_PLUGIN_NAMESPACE$',
                value: 'avia.samsung'
            },
            url: {
                regular: {
                    token: '$PLAYER_SAMSUNG_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/extensions/samsung/avia.samsung.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_SAMSUNG_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.samsung.min.js'
                }
            }
        },
        player_xbox_plugin: {
            namespace: {
                token: '$PLAYER_XBOX_PLUGIN_NAMESPACE$',
                value: 'avia.xbox'
            },
            url: {
                regular: {
                    token: '$PLAYER_XBOX_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/extensions/xbox/avia.xbox.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_XBOX_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.xbox.min.js'
                }
            }
        },
        player_comcast_plugin: {
            namespace: {
                token: '$PLAYER_COMCAST_PLUGIN_NAMESPACE$',
                value: 'avia.comcast'
            },
            url: {
                regular: {
                    token: '$PLAYER_COMCAST_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/extensions/comcast/avia.comcast.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_COMCAST_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.comcast.min.js'
                }
            }
        },
        player_hdcp_plugin: {
            namespace: {
                token: '$PLAYER_HDCP_PLUGIN_NAMESPACE$',
                value: 'avia.hdcp'
            },
            url: {
                regular: {
                    token: '$PLAYER_HDCP_PLUGIN_URL_NORMAL$',
                    value: 'https://avia.vtg.paramount.tech/avia-js/2.46.3/extensions/hdcp/avia.hdcp.min.js'
                }
            },
            file_name: {
                regular: {
                    token: '$PLAYER_HDCP_PLUGIN_FILE_NAME_NORMAL$',
                    value: 'avia.hdcp.min.js'
                }
            }
        },
        utag_pplus: {
            namespace: {
                token: '$UTAG_NAMESPACE$',
                value: 'utag'
            },
            url: {
                regular: {
                    token: '$UTAG_URL_NORMAL$',
                    value: 'https://tags.tiqcdn.com/utag/cbsi/pplus/prod/utag.js'
                }
            }
        },
        utag_cbs: {
            namespace: {
                token: '$UTAG_NAMESPACE$',
                value: 'utag'
            },
            url: {
                regular: {
                    token: '$UTAG_URL_NORMAL$',
                    value: 'https://tags.tiqcdn.com/utag/cbsi/cbstve/prod/utag.js'
                }
            }
        }
    }
};
